/**
 * @see /client/components/RestaurantListCard/index.js
 * @see /client/containers/RestaurantDetails/index.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const RestaurantMaindetails = Styled.div`
    position:relative;
    background:${(props) => props.theme.whiteColor};
    float:left;
    width:75%;
    padding-left:20px;
    .rating{
      background: ${(props) => props.theme.tertiaryColor};
      padding: 5px 8px;
      font-size: 14px;
      font-weight: bold;
      border-radius: 0px;
      position: absolute;
      right: 0px;
      top:0px;
      width:auto;
      margin:auto;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        padding: 5px;
      };
    }
    strong{
      color:${(props) => props.theme.tertiaryColor};
      font-size:14px;
    }
    img{
      width: 35px;
      border-radius: 50%;
      position: absolute;
      left: 5px;
      bottom: 2px;
    }
    h1{
      margin:0px;
      font-size:20px;
      margin-bottom:5px;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 93%;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width: 80%;
      };
      white-space: nowrap;
    }
    p{
      display:block;
      width:70%;
      background:${(props) => props.theme.lightGray};
      text-align:center;
      color:${(props) => props.theme.blackColor};
      float:left;
      padding:10px;
      margin:0px;
      }
    span{
      background:${(props) => props.theme.webGray};
      width:28%;
      float:left;
      margin-left:2%;
      padding:10px;
      text-align:center;
    }
    dl{
      font-size:14px;
      display:inline-block;
      width: 100%;
      margin-bottom:5px;

      dt{
        float:left;
        width:20%;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          width: 40%;
        };
        color:${(props) => props.theme.mediumGrey};
        font-weight:bold;
        margin:5px 0px;
        font-size:13px;
      }
      dd{
        float:left;
        width:80%;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          width: 60%;
        };
        margin:5px 0px;
        b{
          color:${(props) => props.theme.lightGray};
          font-weight:bold;
          float:left;
          margin-right:10px;
        }
        ul{
          list-style:none;
          margin:0px;
          padding:0px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          li{
            display:inline-block;
            border-right:${(props) => props.theme.secondaryColor} solid 1px;
            padding:0px 8px;
            &:last-child{
              border-right:none;
            }
            &:first-child{
              padding-left:0px;
            }
          }
        }
      }
    }
`;

/**
 * @param {*object} props
 */
function RestaurantMainDetails(props) {
  const { restaurantName, restaurantArea, cost, tags, cuisines, rating, onClick, merchant_id, cashBack } = props;
  return (
    <RestaurantMaindetails>
      {rating > 0 ? <span className="rating">{rating}</span> : ''}
      <h1 onClick={() => onClick(merchant_id)} role="presentation">{restaurantName}</h1>
      <strong>{restaurantArea}</strong>
      <br clear="all" />
      <dl>
        <dt>Cuisines</dt>
        <dd><b>:</b>
          <ul>
            {cuisines && cuisines.map((cuisine) => <li key={cuisine}>{cuisine}</li>)}
          </ul>
        </dd>
        <dt>Cost for Two</dt>
        <dd><b>:</b>&#8377;&nbsp;{cost}</dd>
        {/* {tags && tags.length ?
          <span><dt>Tagged in</dt>
            <dd>
              <b>:</b>
              <ul>
                {tags.map((tag) => <li key={tag}>{tag}</li>)}
              </ul>
            </dd>
          </span> : ''} */}
      </dl>
      {/* <br clear="all" />
      <div style={{ display: cashBack ? '' : 'none' }}>
        <img src="https://dummyimage.com/50x50/ff0000/ffffff&img" alt="" />
        <p>Pay using Zaggle App and get additional <b>{cashBack}</b></p>
        <span>No cost EMI available</span>
      </div> */}
    </RestaurantMaindetails>
  );
}

/**
 * @todo:'cuisines' sometime server is giving boolean false also need to handle that
 */
RestaurantMainDetails.defaultProps = {
  cuisines: [],
  tags: [], // not available in the API
  onClick: () => '',
  merchant_id: null,
};

RestaurantMainDetails.propTypes = {
  rating: PropTypes.oneOfType([ // sometime type is changing to number or string
    PropTypes.string,
    PropTypes.number,
  ]),
  restaurantName: PropTypes.string,
  restaurantArea: PropTypes.string,
  cost: PropTypes.number,
  tags: PropTypes.array,
  cuisines: PropTypes.array,
  cashBack: PropTypes.string,
  onClick: PropTypes.func,
  merchant_id: PropTypes.string,
};

export default RestaurantMainDetails;



// WEBPACK FOOTER //
// client/containers/RestaurantDetails/RestaurantMainDetails.js